import { Avatar, Input } from 'antd';
import { IChat } from 'interfaces';
import { useMemo, useState } from 'react';
import { TFunction } from 'i18next';
import classes from './ChatSettings.module.scss';

type Props = { chatInfo: IChat; t: TFunction };

const MemberController = ({ chatInfo, t }: Props) => {
  const [searchTerm, setSearchTerm] = useState('');
  const { members } = chatInfo;
  const filteredUsers = useMemo(
    () => members.filter(({ email, name }) => `${email} ${name}`.toLowerCase().includes(searchTerm.toLowerCase())),
    [searchTerm, members]
  );

  return (
    <div className={classes.members}>
      <div className={classes.divider}>{t('Chats.settings.members')}: {filteredUsers.length}</div>
      {chatInfo.entity_type !== 3 && chatInfo.entity_type !== 2 && (
        <Input.Search onChange={(e) => setSearchTerm(e.target.value)} />
      )}
      <div>
        {filteredUsers.map(({ name, email }) => (
          <div key={email} className={classes.members_item}>
            <div className={classes.avatarWrap}>
              <Avatar className={classes.avatar}>
                <span className={classes.avatarWord}>{name[0]}</span>
              </Avatar>
            </div>
            <div className={classes.info}>
              {' '}
              <div>{name}</div>
              <div>{email}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MemberController;
